export default __webpack_public_path__ + "static/media/DesignImg.f4c70335.png";